import React from "react";

const DeleteModal = ({ isOpen, onCancel, onDelete, showDelete, setShowDelete }) => {
  if (!isOpen && !showDelete) return null;
  

  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-10 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg p-6 w-80 text-center">
            <div className="flex justify-center mb-4">
              <div className="bg-red-600 w-14 h-14 rounded-full flex items-center justify-center">
                <span className="text-white text-3xl font-bold">?</span>
              </div>
            </div>
            <p className="text-lg font-medium mb-6">Do you want to delete this Unit ?</p>
            <div className="flex justify-between gap-4">
              <button
                onClick={onCancel}
                className="border border-red-600 text-red-600 font-semibold px-5 py-2 rounded w-full hover:bg-red-50"
              >
                Cancel
              </button>
              <button
  onClick={() => {
    onDelete();          // trigger delete logic
  }}
  className="bg-red-600 text-white font-semibold px-5 py-2 rounded w-full hover:bg-red-700"
>
  Delete
</button>
            </div>
          </div>
        </div>
      )}

      {showDelete && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-10 z-50">
          <div className="bg-white p-6 rounded-lg text-center shadow-lg">
            <div className="flex justify-center mb-4">
              <div className="bg-red-600 text-white rounded-full w-12 h-12 flex items-center justify-center text-3xl">
                ✔
              </div>
            </div>
            <p className="text-lg font-normal">Unit Deleted Successfully!!! ✅</p>
            <button
              onClick={() => setShowDelete(false)}
              className="bg-red-600 text-white px-6 py-2 mt-4 rounded hover:bg-red-700"
            >
              Done
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default DeleteModal;
